import { FormControl as UIFormControl, VStack } from "@gluestack-ui/themed";
import { FormControlProps } from "./types";
import { InputLabel } from "./components/InputLabel";
import { InputHelperText } from "./components/InputHelperText";
import { InputError } from "./components/InputError";

export const FormControl = ({
  children,
  isDisabled,
  isInvalid,
  isReadOnly,
  isRequired,
  errorMessage,
  isLoading,
  label,
  helperText,
}: FormControlProps) => {
  return (
    <UIFormControl
      isDisabled={isDisabled || isLoading}
      isInvalid={isInvalid || !!errorMessage}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
    >
      <InputLabel label={label} />
      <VStack flex={1} width={"$full"}>
        {children}
      </VStack>
      <InputHelperText text={helperText} hasError={!!errorMessage} />
      <InputError errorMessage={errorMessage} />
    </UIFormControl>
  );
};
